import React, { useEffect } from "react";
import { Button, DatePicker, Select, Tooltip, Row, Col } from "antd";
import dayjs from "dayjs";
import { chartOptions, dateRanges } from "../Data/data";
import { Box, Typography } from "@mui/material";

const { RangePicker } = DatePicker;
const { Option } = Select;

const DateEngineChartSelectorCompany = ({
  selectedDates,
  setSelectedDates,
  engineType,
  setEngineType,
  selectedChart,
  setSelectedChart,
  selectedParameters,
  setSelectedParameters,
  setStartDate,
  setEndDate,
  Graph_data,
  ship_table_list,
  set_ship_id,
  ship_id,
  timeFormat,
  setTimeFormat,
  engineOptions,
  parameterMappings,
  setSelectedLogbook,
  selectedLogbook,
}) => {
  useEffect(() => {
    if (selectedDates && selectedDates.length === 2) {
      const startDate = dayjs(selectedDates[0]).format("YYYY-MM-DD");
      const endDate = dayjs(selectedDates[1]).format("YYYY-MM-DD");
      setStartDate(startDate);
      setEndDate(endDate);
    }
  }, [selectedDates, setStartDate, setEndDate]);

  // Default engine type on mount
  // useEffect(() => {
  //   if (engineOptions.length > 0 && (!engineType || engineType.length === 0)) {
  //     const firstValue = [engineOptions[0].value];
  //     setEngineType(firstValue);
  //   }
  // }, [engineOptions, engineType, setEngineType]);

  // Default date range (last 2 days)
  useEffect(() => {
    if (!selectedDates || selectedDates.length === 0) {
      setSelectedDates([dayjs().subtract(2, "day"), dayjs()]);
    }
  }, [selectedDates, setSelectedDates]);


  // Handlers
  const handleDateChange = (dates) => setSelectedDates(dates);
  // const handleLogbookChange = (value) => setSelectedLogbook(value);
   const handleLogbookChange = (item) => {
  setSelectedLogbook(item);

  // if (value === "deck_logbook" || value === "daily_consumption_log") {
  //   setSelectedParameters([]);
  // }
};
  const handleEngineChange = (value) => setEngineType(value);
  const handleChartChange = (value) => setSelectedChart(value);

  const handleParameterChange = (values) => {
    const allParams = Object.values(parameterMappings || {}).flat();
    const selected = allParams
      .filter((p) => values.includes(p.value))
      .map((p) => ({ value: p.value, type: p.type }));
    setSelectedParameters(selected);
  };

  return (
    <div style={{ padding: 10 }}>
      <Row gutter={[16, 16]}>
        {/* Ship Selector */}
        <Col xs={24} sm={12} md={8} lg={6}>
          <div className="selector-label">Select Ship</div>
          <Select
            placeholder="---- Select Ship ----"
            style={{ width: "100%" }}
            value={ship_id}
            // onChange={(value) => set_ship_id(value)}
            onChange={(value) => set_ship_id(Number(value))}
          >
            {ship_table_list?.map(
              (ship) =>
                ship.status &&
                !ship.soft_delete && (
                  <Option key={ship.id} value={ship.id}>
                    {ship.vessel_name}
                  </Option>
                )
            )}
          </Select>
        </Col>

        {/* Date Range */}
        <Col xs={24} sm={12} md={8} lg={6}>
          <div className="selector-label">Select Date Range</div>
          <RangePicker
            presets={dateRanges}
            onChange={handleDateChange}
            value={
              selectedDates && selectedDates.length
                ? [dayjs(selectedDates[0]), dayjs(selectedDates[1])]
                : null
            }
            format="YYYY-MM-DD"
            style={{ width: "100%" }}
            disabledDate={(current) =>
              current && current > dayjs().endOf("day")
            }
          />
        </Col>

        <Col xs={24} sm={12} md={8} lg={6}>
                  <div className="selector-label">Select Logbook</div>
                  <Select
                    mode="multiple"
                    showSearch
                    placeholder="Select Logbook Type"
                    maxTagCount={1}
                    onChange={handleLogbookChange}
                    value={selectedLogbook || undefined}
                    style={{ width: "100%" }}
                    filterOption={(input, option) =>
                      option.children.toLowerCase().includes(input.toLowerCase())
                    }
                  >
                    <Option value="engine_logbook">Engine Logbook</Option>
                    <Option value="deck_logbook">Deck Logbook</Option>
                    <Option value="daily_consumption_log">
                      Daily Consumption Log
                    </Option>
                  </Select>
                </Col>

                {selectedLogbook.includes("engine_logbook") && (
                  <>
                   <Col xs={24} sm={12} md={8} lg={6}>
          <div className="selector-label">Select Machinery Type</div>
          <Select
            mode="multiple"
            showSearch
            placeholder="Select machinery type"
            onChange={handleEngineChange}
            value={engineType || []}
            style={{ width: "100%" }}
            maxTagCount={1}
            maxTagPlaceholder={(omittedValues) => (
              <Tooltip
                title={omittedValues.map(({ label }) => label).join(", ")}
              >
                <span>+{omittedValues.length} more</span>
              </Tooltip>
            )}
            filterOption={(input, option) =>
              String(option?.children)
                .toLowerCase()
                .includes(input.toLowerCase())
            }
          >
            {engineOptions.map((engine) => (
              <Option key={engine.value} value={engine.value}>
                {engine.label}
              </Option>
            ))}
          </Select>
        </Col>
                  </>
)}
     

        {/* Parameters */}
        <Col xs={24} sm={12} md={8} lg={6}>
          <div className="selector-label">Select Parameters</div>
          <Select
            mode="multiple"
            showSearch
            placeholder="Select Parameters"
            onChange={handleParameterChange}
            value={selectedParameters?.map((p) => p.value)}
            style={{ width: "100%" }}
            maxTagCount={1}
            maxTagPlaceholder={(omittedValues) => (
              <Tooltip
                title={omittedValues.map(({ label }) => label).join(", ")}
              >
                <span>+{omittedValues.length} more</span>
              </Tooltip>
            )}
            filterOption={(input, option) =>
              String(option?.children)
                .toLowerCase()
                .includes(input.toLowerCase())
            }
          >
            {Object.values(parameterMappings || {})
              .flat()
              .map((param) => (
                <Option key={param.value} value={param.value}>
                  {param.label}
                </Option>
              ))}
          </Select>
        </Col>

        
        {/* Chart Type */}
        <Col xs={24} sm={12} md={8} lg={6}>
          <div className="selector-label">Select Chart Type</div>
          <Select
            showSearch
            placeholder="Select a chart type"
            onChange={handleChartChange}
            value={selectedChart || undefined}
            style={{ width: "100%" }}
          >
            {chartOptions?.map((chart) => (
              <Option key={chart.value} value={chart.value}>
                {chart.label}
              </Option>
            ))}
          </Select>
        </Col>

        {/* Time Format */}
        <Col xs={24} sm={12} md={8} lg={6}>
          <div className="selector-label">Time Format</div>
          <Select
            value={timeFormat}
            style={{ width: "100%" }}
            onChange={setTimeFormat}
            options={[
              { label: "Daily", value: "daily" },
              { label: "Weekly", value: "weekly" },
              { label: "Monthly", value: "monthly" },
            ]}
          />
        </Col>

        {/* Button */}
        <Col xs={24} sm={12} md={8} lg={6}>
          <Button
            type="primary"
            block
            className="generate-btn"
            style={{
              marginTop: "10px",
            }}
            onClick={Graph_data}
          >
            Generate Graph
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default DateEngineChartSelectorCompany;
